(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4109],{

/***/ 5560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PageWithFiltersWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/dist/index.mjs
var dist = __webpack_require__(18357);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/lib/algolia/serialize-algolia-results.ts
var serialize_algolia_results = __webpack_require__(52763);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Spinner/index.js
var Spinner = __webpack_require__(38137);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/AlgoliaSearchProvider/hooks/useAlgoliaQueryContext.js
var useAlgoliaQueryContext = __webpack_require__(71127);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/hooks/search/useAlgoliaSearch/index.js + 3 modules
var useAlgoliaSearch = __webpack_require__(70296);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-ecommerce-hooks/dist/es/providers/AlgoliaSearchProvider/index.js + 5 modules
var AlgoliaSearchProvider = __webpack_require__(11062);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useIsMountedState/index.js
var useIsMountedState = __webpack_require__(23893);
// EXTERNAL MODULE: ./src/components/Navigation/NavigationBanner/index.tsx
var NavigationBanner = __webpack_require__(64061);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
;// CONCATENATED MODULE: ./src/components/PageWithFilters/NoResults/index.tsx






function NoResults(param) {
    var className = param.className;
    var t = (0,lib/* useTranslate */.qM)();
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Title24SangBleu */.C.Title24SangBleu
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: classnames_default()(className, titleStyle),
        children: t(dictionary/* FILTER.NO_RESULTS */.gU.NO_RESULTS)
    });
}

// EXTERNAL MODULE: ./src/components/Slices/ImageWithLabel/index.tsx
var ImageWithLabel = __webpack_require__(53299);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./src/components/UI/Image/index.tsx
var Image = __webpack_require__(51025);
// EXTERNAL MODULE: ./src/components/UI/InlineCta/index.tsx + 1 modules
var InlineCta = __webpack_require__(85499);
// EXTERNAL MODULE: ./src/components/UI/FilteredProductsGrid/FilteredHeaderBlock/styles.module.scss
var styles_module = __webpack_require__(3207);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/UI/FilteredProductsGrid/FilteredHeaderBlock/index.tsx














var IMAGES_SIZES = [
    {
        breakpoint: "md",
        ratio: 1 / 3
    },
    {
        ratio: 1
    }
];
var cx = bind_default().bind((styles_module_default()));
function FilteredHeaderBlock(param) {
    var className = param.className, bio = param.bio, bioTruncated = param.bioTruncated, bioIsTruncated = param.bioIsTruncated, bioImage = param.bioImage, materials = param.materials, origin = param.origin, family = param.family, shops = param.shops, responsibilities = param.responsibilities, colors = param.colors;
    var ref = (0,_sliced_to_array/* default */.Z)((0,NavigationBanner/* useNavBannerContext */.DI)(), 1), isVisible = ref[0];
    var textStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text14GroteskRegular */.C.Text14GroteskRegular
    });
    var listElemStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskMedium */.C.Text12GroteskMedium,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var listElemSmallStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskRegular */.C.Text12GroteskRegular
    });
    var t = (0,lib/* useTranslate */.qM)();
    var ref1 = (0,react.useState)(false), expanded = ref1[0], setExpanded = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx((styles_module_default()).FilteredHeaderBlock, className, {
            isBannerVisible: isVisible
        }),
        children: [
            bioTruncated && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx((styles_module_default()).text, textStyle),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            bioTruncated && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: cx((styles_module_default()).bio),
                                children: bioIsTruncated ? expanded ? bio : bioTruncated : bioTruncated
                            }),
                            !expanded && (bioImage || bioIsTruncated) && /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, {
                                className: (styles_module_default()).readMore,
                                textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
                                isDiv: true,
                                onClick: function() {
                                    return setExpanded(true);
                                },
                                children: t(dictionary/* CTA.READ_MORE */.MV.READ_MORE)
                            })
                        ]
                    }),
                    expanded && bioImage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({
                                className: cx((styles_module_default()).bioImage),
                                layout: "responsive",
                                objectFit: "cover",
                                asPlaceholder: true,
                                sizesFromBreakpoints: IMAGES_SIZES
                            }, bioImage)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, {
                                className: (styles_module_default()).readLess,
                                textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
                                isDiv: true,
                                onClick: function() {
                                    return setExpanded(false);
                                },
                                children: t(dictionary/* CTA.READ_LESS */.MV.READ_LESS)
                            })
                        ]
                    })
                ]
            }),
            origin && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx((styles_module_default()).origin, listElemStyle),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: t(dictionary/* FILTERED_PAGE_HEADER_TITLES.ORIGIN */.tD.ORIGIN)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: origin
                    })
                ]
            }),
            family && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx((styles_module_default()).origin, listElemStyle),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: t(dictionary/* FILTERED_PAGE_HEADER_TITLES.FAMILY */.tD.FAMILY)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: family
                    })
                ]
            }),
            (shops === null || shops === void 0 ? void 0 : shops.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx((styles_module_default()).shops, listElemStyle),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: t(dictionary/* FILTERED_PAGE_HEADER_TITLES.STORE */.tD.STORE)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx((styles_module_default()).elements),
                        children: shops === null || shops === void 0 ? void 0 : shops.map(function(shop, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread/* default */.Z)({
                                textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
                                className: cx((styles_module_default()).shop)
                            }, shop), "shop_link_".concat(key));
                        })
                    })
                ]
            }),
            (materials === null || materials === void 0 ? void 0 : materials.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx((styles_module_default()).materials),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: listElemStyle,
                        children: t(dictionary/* FILTERED_PAGE_HEADER_TITLES.MATERIALS */.tD.MATERIALS)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx((styles_module_default()).elements, listElemStyle),
                        children: materials === null || materials === void 0 ? void 0 : materials.join(", ")
                    })
                ]
            }),
            (responsibilities === null || responsibilities === void 0 ? void 0 : responsibilities.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx((styles_module_default()).responsibilities),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx(listElemStyle),
                        children: t(dictionary/* FILTERED_PAGE_HEADER_TITLES.RESPONSIBILITIES */.tD.RESPONSIBILITIES)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx((styles_module_default()).elements),
                        children: responsibilities.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: cx((styles_module_default()).responsibility, listElemSmallStyle),
                                children: item
                            }, "item_responsibility_".concat(index));
                        })
                    })
                ]
            }),
            (colors === null || colors === void 0 ? void 0 : colors.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx((styles_module_default()).responsibilities),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx(listElemStyle),
                        children: t(dictionary/* FILTERED_PAGE_HEADER_TITLES.COLORS */.tD.COLORS)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx((styles_module_default()).elements),
                        children: colors.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: cx((styles_module_default()).responsibility, listElemSmallStyle),
                                children: item
                            }, "item_colors_".concat(index));
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var FilteredProductsGrid_FilteredHeaderBlock = (FilteredHeaderBlock);

// EXTERNAL MODULE: ./src/components/UI/ProductCard/index.tsx + 8 modules
var ProductCard = __webpack_require__(23816);
// EXTERNAL MODULE: ./src/components/UI/FilteredProductsGrid/Results/styles.module.scss
var Results_styles_module = __webpack_require__(38071);
var Results_styles_module_default = /*#__PURE__*/__webpack_require__.n(Results_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/FilteredProductsGrid/Results/index.tsx







var Results_cx = bind_default().bind((Results_styles_module_default()));
function Results(param) {
    var items = param.items, itemClassName = param.itemClassName, layout = param.layout, withPriority = param.withPriority;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (ref = items === null || items === void 0 ? void 0 : items.map(function(product, index) {
            return /*#__PURE__*/ (0,react.createElement)(ProductCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                key: "card_".concat(layout, "_").concat(index),
                layout: layout,
                className: Results_cx((Results_styles_module_default()).product, itemClassName),
                priority: withPriority && index === 0
            }));
        })) !== null && ref !== void 0 ? ref : null
    });
}
/* harmony default export */ var FilteredProductsGrid_Results = (Results);

// EXTERNAL MODULE: ./src/components/UI/ProductCard/types.ts
var types = __webpack_require__(72206);
// EXTERNAL MODULE: ./src/providers/FilterProvider/index.tsx
var FilterProvider = __webpack_require__(42193);
// EXTERNAL MODULE: ./src/providers/LayoutSwitcherProvider/index.tsx
var LayoutSwitcherProvider = __webpack_require__(70306);
// EXTERNAL MODULE: ./src/providers/PaginationProvider/index.tsx
var PaginationProvider = __webpack_require__(49981);
// EXTERNAL MODULE: ./src/utils/maths/random.ts
var random = __webpack_require__(6877);
// EXTERNAL MODULE: ./src/components/UI/FilteredProductsGrid/styles.module.scss
var FilteredProductsGrid_styles_module = __webpack_require__(40986);
var FilteredProductsGrid_styles_module_default = /*#__PURE__*/__webpack_require__.n(FilteredProductsGrid_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/FilteredProductsGrid/index.tsx

















var FilteredProductsGrid_cx = bind_default().bind((FilteredProductsGrid_styles_module_default()));
var _obj;
var HITS_CHUNKS = (_obj = {}, (0,_define_property/* default */.Z)(_obj, LayoutSwitcherProvider/* LAYOUT.BIG */._.BIG, 3), (0,_define_property/* default */.Z)(_obj, LayoutSwitcherProvider/* LAYOUT.MEDIUM */._.MEDIUM, 4), (0,_define_property/* default */.Z)(_obj, LayoutSwitcherProvider/* LAYOUT.SMALL */._.SMALL, 6), _obj);
var _obj1;
var MOBILE_HITS_CHUNKS = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, LayoutSwitcherProvider/* LAYOUT.BIG */._.BIG, 1), (0,_define_property/* default */.Z)(_obj1, LayoutSwitcherProvider/* LAYOUT.MEDIUM */._.MEDIUM, 2), _obj1);
var _obj2;
var GRID_LAYOUT = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, LayoutSwitcherProvider/* LAYOUT.BIG */._.BIG, types/* CARD_PRODUCT_LAYOUT.BIG_GRID */.u.BIG_GRID), (0,_define_property/* default */.Z)(_obj2, LayoutSwitcherProvider/* LAYOUT.MEDIUM */._.MEDIUM, types/* CARD_PRODUCT_LAYOUT.MEDIUM_GRID */.u.MEDIUM_GRID), (0,_define_property/* default */.Z)(_obj2, LayoutSwitcherProvider/* LAYOUT.SMALL */._.SMALL, types/* CARD_PRODUCT_LAYOUT.SMALL_GRID */.u.SMALL_GRID), _obj2);
var RANDOM_IMAGES_LENGTH = 2;
var getUniqueIndex = function(param) {
    var array = param.array, maxIndex = param.maxIndex;
    var index = (0,random/* randomIntFromInterval */.l)(0, maxIndex);
    if (array.includes(index)) {
        return getUniqueIndex({
            array: array,
            maxIndex: maxIndex
        });
    } else {
        return index;
    }
};
function FilteredProductsGrid(param) {
    var className = param.className, results = param.results, hasResults = param.hasResults, filteredHeaderBlock = param.filteredHeaderBlock, customLayout = param.customLayout, maxPage = param.maxPage, randomImages = param.randomImages, withPriority = param.withPriority;
    var ref;
    var step = (0,LayoutSwitcherProvider/* useLayoutSwitcherProvider */.dX)().step;
    var currentPage = (0,PaginationProvider/* usePagination */.h0)().currentPage;
    var withCustomHeader = filteredHeaderBlock && currentPage === 1;
    var ref1 = (0,react.useState)(null), images = ref1[0], setImages = ref1[1];
    // if there are no randomImages from storyblok, we take the images hover from the products cards
    var randomImagesBank = randomImages !== null && randomImages !== void 0 ? randomImages : (ref = results === null || results === void 0 ? void 0 : results.filter(function(result) {
        var ref;
        return result === null || result === void 0 ? void 0 : (ref = result.imageHover) === null || ref === void 0 ? void 0 : ref.data;
    })) === null || ref === void 0 ? void 0 : ref.map(function(result) {
        return result === null || result === void 0 ? void 0 : result.imageHover;
    });
    var getRandomImagesIndexes = function(maxIndex) {
        var ref, ref1;
        return (ref1 = (ref = Array(RANDOM_IMAGES_LENGTH)) === null || ref === void 0 ? void 0 : ref.fill(null)) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(acc, curr, _, initial) {
            var index = (initial === null || initial === void 0 ? void 0 : initial.length) > maxIndex + 1 ? (0,random/* randomIntFromInterval */.l)(0, maxIndex) : getUniqueIndex({
                array: acc,
                maxIndex: maxIndex
            });
            return (0,_to_consumable_array/* default */.Z)(acc).concat([
                index
            ]);
        }, []);
    };
    (0,react.useEffect)(function() {
        if (currentPage > 1 && currentPage < maxPage && customLayout && !withCustomHeader && (randomImagesBank === null || randomImagesBank === void 0 ? void 0 : randomImagesBank.length) > 0 && (results === null || results === void 0 ? void 0 : results.length) === FilterProvider/* HITS_PER_PAGE.FILTERED */.Iq.FILTERED) {
            var ref;
            var randomIndexes = getRandomImagesIndexes((randomImagesBank === null || randomImagesBank === void 0 ? void 0 : randomImagesBank.length) - 1);
            var ref1;
            setImages((ref = randomIndexes === null || randomIndexes === void 0 ? void 0 : randomIndexes.map(function(index) {
                return (ref1 = randomImagesBank === null || randomImagesBank === void 0 ? void 0 : randomImagesBank[index]) !== null && ref1 !== void 0 ? ref1 : null;
            })) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                return item;
            }));
        } else {
            setImages(null);
        }
    }, [
        currentPage,
        results
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: FilteredProductsGrid_cx((FilteredProductsGrid_styles_module_default()).ProductsGrid, className, (FilteredProductsGrid_styles_module_default()) === null || (FilteredProductsGrid_styles_module_default()) === void 0 ? void 0 : (FilteredProductsGrid_styles_module_default())[step], {
            customLayout: Boolean(customLayout || withCustomHeader)
        }),
        children: [
            withCustomHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FilteredProductsGrid_styles_module_default()).customDetails,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilteredProductsGrid_FilteredHeaderBlock, (0,_object_spread/* default */.Z)({
                    className: (FilteredProductsGrid_styles_module_default()).custom
                }, filteredHeaderBlock))
            }),
            hasResults ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FilteredProductsGrid_Results, {
                layout: GRID_LAYOUT[step],
                items: results,
                withPriority: withPriority
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResults, {
                className: (FilteredProductsGrid_styles_module_default()).noResults
            }),
            images && (images === null || images === void 0 ? void 0 : images.length) > 0 && (images === null || images === void 0 ? void 0 : images.map(function(image, i) {
                var ref;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FilteredProductsGrid_styles_module_default()).imageContainer,
                    style: {
                        gridColumn: i * 2 + 1,
                        gridRow: i * 2 + 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({
                        className: FilteredProductsGrid_cx((FilteredProductsGrid_styles_module_default()).image),
                        draggable: false,
                        sizesFromBreakpoints: ImageWithLabel/* IMAGE_SIZE */.WQ[GRID_LAYOUT[step]],
                        layout: "fill",
                        objectFit: "cover",
                        asPlaceholder: true,
                        loader: (image === null || image === void 0 ? void 0 : image.loaderType) === types/* CARD_IMAGE_LOADER.STORYBLOK */.p.STORYBLOK ? Image/* imageLoaderStoryblok */.y : null
                    }, image === null || image === void 0 ? void 0 : image.data))
                }, "".concat(image === null || image === void 0 ? void 0 : (ref = image.data) === null || ref === void 0 ? void 0 : ref.src, "-").concat(i));
            }))
        ]
    });
}
/* harmony default export */ var UI_FilteredProductsGrid = (FilteredProductsGrid);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/Abstracts/Icons/index.tsx + 15 modules
var Icons = __webpack_require__(1815);
// EXTERNAL MODULE: ./src/components/UI/SquaredCta/index.tsx
var SquaredCta = __webpack_require__(35007);
// EXTERNAL MODULE: ./src/providers/PanelProvider/index.tsx
var PanelProvider = __webpack_require__(92397);
// EXTERNAL MODULE: ./src/components/UI/FiltersTrigger/styles.module.scss
var FiltersTrigger_styles_module = __webpack_require__(63159);
var FiltersTrigger_styles_module_default = /*#__PURE__*/__webpack_require__.n(FiltersTrigger_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/FiltersTrigger/index.tsx










var FiltersTrigger_cx = bind_default().bind((FiltersTrigger_styles_module_default()));
var FiltersPanel = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4172).then(__webpack_require__.bind(__webpack_require__, 44172));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44172)
            ];
        }
    }
});
function FiltersTrigger(param) {
    var className = param.className;
    var t = (0,lib/* useTranslate */.qM)();
    var ref = (0,PanelProvider/* usePanel */.uR)(), addPanel = ref.add;
    var openFiltersPanel = function(e) {
        addPanel({
            component: /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersPanel, {}),
            direction: "right"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SquaredCta/* default */.Z, {
        className: FiltersTrigger_cx((FiltersTrigger_styles_module_default()).FiltersTrigger, className),
        withBackground: true,
        withBorder: true,
        theme: colors/* GlobalThemeColors.White */.b.White,
        onClick: openFiltersPanel,
        children: [
            t(dictionary/* CTA.FILTER_SORT */.MV.FILTER_SORT),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* PlusIcon */.pO, {
                className: (FiltersTrigger_styles_module_default()).icon
            })
        ]
    });
}
FiltersTrigger.defaultProps = {};
/* harmony default export */ var UI_FiltersTrigger = (FiltersTrigger);

// EXTERNAL MODULE: ./src/components/UI/Pagination/index.tsx + 1 modules
var Pagination = __webpack_require__(20449);
// EXTERNAL MODULE: ./src/hooks/useLocale/index.ts
var useLocale = __webpack_require__(66794);
// EXTERNAL MODULE: ./src/utils/deep-equal.ts
var deep_equal = __webpack_require__(72341);
// EXTERNAL MODULE: ./src/utils/get-algolia-product-index.ts
var get_algolia_product_index = __webpack_require__(17831);
// EXTERNAL MODULE: ./src/utils/get-query-params.ts
var get_query_params = __webpack_require__(16731);
// EXTERNAL MODULE: ./src/components/PageWithFilters/styles.module.scss
var PageWithFilters_styles_module = __webpack_require__(35995);
var PageWithFilters_styles_module_default = /*#__PURE__*/__webpack_require__.n(PageWithFilters_styles_module);
;// CONCATENATED MODULE: ./src/components/PageWithFilters/index.tsx





























var PageWithFilters_cx = bind_default().bind((PageWithFilters_styles_module_default()));
var REMOVABLE_EMPTY_KEYS = [
    FilterProvider/* OrderingFilters.ORDER_BY */.nw.ORDER_BY,
    FilterProvider/* NumericFilters.PRICE */.qS.PRICE,
    "layout", 
];
/**
 * It returns the index name to use for the search query
 * @param sortBy - The sortBy value that the user has selected.
 * @param defaultIndex - The default index to use if the user has not selected a sortBy value.
 * @param locale - The locale of the current user.
 * @returns the indice to use.
 */ function getIndiceFromSortBy(sortBy, defaultIndex, locale) {
    var indexName = (0,get_algolia_product_index/* default */.Z)();
    // define if use selected default sortBy
    var isDefaultSort = (sortBy !== null && sortBy !== void 0 ? sortBy : FilterProvider/* SortByValues.DEFAULT */.q9.DEFAULT) === FilterProvider/* SortByValues.DEFAULT */.q9.DEFAULT;
    // set our default value according to the provided defaultIndex
    var defaultValue = defaultIndex ? defaultIndex : "".concat(locale, "_").concat(indexName);
    // if default selected return default value
    // else return user selection sortBy
    return isDefaultSort ? defaultValue : "".concat(locale, "_").concat(indexName, "_").concat(sortBy);
}
var getReducedQueryValuesForFilters = function(facets) {
    return function(cur, param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        var isDefaultOrderByValue = key === FilterProvider/* OrderingFilters.ORDER_BY */.nw.ORDER_BY && value === FilterProvider/* SortByValues.DEFAULT */.q9.DEFAULT;
        var isDefaultLayoutValue = key === "layout" && value === LayoutSwitcherProvider/* LAYOUT.MEDIUM */._.MEDIUM;
        var isDefaultPriceRangeValue = key === FilterProvider/* NumericFilters.PRICE */.qS.PRICE && JSON.stringify((0,FilterProvider/* getMinMaxValuesFromFacet */.NT)(FilterProvider/* NumericFilters.PRICE */.qS.PRICE, facets)) === value;
        if (isDefaultOrderByValue || isDefaultLayoutValue || isDefaultPriceRangeValue) return Object.assign(cur, (0,_define_property/* default */.Z)({}, key, []));
        if (!value) return cur;
        return Object.assign(cur, (0,_define_property/* default */.Z)({}, key, value));
    };
};
function PageWithFilters(param) {
    var children = param.children, _customLayout = param.customLayout, customLayout = _customLayout === void 0 ? false : _customLayout, filteredHeader = param.filteredHeader, initialFilters = param.initialFilters, defaultIndex = param.defaultIndex, randomImages = param.randomImages, withPriority = param.withPriority;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,NavigationBanner/* useNavBannerContext */.DI)(), 1), isVisible = ref9[0];
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: "base-grid"
    });
    var router = (0,next_router.useRouter)();
    var params = (0,react.useMemo)(function() {
        return (0,get_query_params/* getQueryParams */.vl)();
    }, [
        router
    ]);
    var locale = (0,useLocale/* default */.Z)();
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useAlgoliaQueryContext/* useAlgoliaQueryContext */.I)(), 2), _ = ref10[0], setQuery = ref10[1];
    var filteredParamsFromUrl = (0,FilterProvider/* getFilteredAlgoliaParams */._O)(params !== null && params !== void 0 ? params : {});
    var initialQuery = (0,react.useRef)(_);
    var ref11 = (0,useAlgoliaSearch/* useAlgoliaSearch */.x)(), data = ref11.data, isSuccess = ref11.isSuccess, isFetching = ref11.isFetching;
    var ref12 = (0,dist/* useInView */.YD)({
        threshold: 0.2
    }), inViewRef = ref12.ref, inView = ref12.inView, entry = ref12.entry;
    var isInview = inView || (entry === null || entry === void 0 ? void 0 : (ref = entry.boundingClientRect) === null || ref === void 0 ? void 0 : ref.y) <= 0;
    // use mounted state to prevent superfluous router push on first render
    var mounted = (0,useIsMountedState/* useIsMountedState */.h)();
    var ref13 = (0,FilterProvider/* useFilter */.L0)(), facets = ref13.facets, filters = ref13.filters, setFilters = ref13.setFilters, defaultFilters = ref13.defaultFilters, hitsPerPage = ref13.hitsPerPage;
    var ref14 = (0,PaginationProvider/* usePagination */.h0)(), currentPage = ref14.currentPage, routerPush = ref14.routerPush, algoliaPage = ref14.algoliaPage;
    var ref15 = (0,LayoutSwitcherProvider/* useLayoutSwitcherProvider */.dX)(), step = ref15.step, setStep = ref15.setStep;
    var isMounted = (0,react.useRef)(false);
    var facetFilters = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)((0,FilterProvider/* getFacetsFiltersFromFilters */.ty)(filters)).concat((0,_to_consumable_array/* default */.Z)((0,FilterProvider/* getFacetsFiltersFromFilters */.ty)(defaultFilters !== null && defaultFilters !== void 0 ? defaultFilters : {})));
    }, [
        JSON.stringify(filters !== null && filters !== void 0 ? filters : {})
    ]);
    var sortBy = (0,react.useMemo)(function() {
        var ref;
        return (ref = filters === null || filters === void 0 ? void 0 : filters[FilterProvider/* OrderingFilters.ORDER_BY */.nw.ORDER_BY]) !== null && ref !== void 0 ? ref : null;
    }, [
        JSON.stringify(filters !== null && filters !== void 0 ? filters : {})
    ]);
    var numericFilters = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        var minMaxValues = (0,FilterProvider/* getMinMaxValuesFromFacet */.NT)(FilterProvider/* NumericFilters.PRICE */.qS.PRICE, facets);
        var ref4;
        return (ref4 = (ref3 = (ref2 = (ref1 = (ref = Object.keys(filters)) === null || ref === void 0 ? void 0 : ref.filter(function(filter) {
            return (filters === null || filters === void 0 ? void 0 : filters[filter]) && Object.values(FilterProvider/* NumericFilters */.qS).includes(filter);
        })) === null || ref1 === void 0 ? void 0 : ref1.map(function(filter) {
            var values = JSON.parse(filters[filter]);
            // Avoid rewriting numeric filter if price filter is equal to default
            if (JSON.stringify(values) === JSON.stringify(minMaxValues)) return [];
            return values.map(function(val, i) {
                return "numeric_price ".concat(i === 0 ? ">= ".concat(val) : "<= ".concat(val));
            });
        })) === null || ref2 === void 0 ? void 0 : ref2.flat()) === null || ref3 === void 0 ? void 0 : ref3.join(" AND ")) !== null && ref4 !== void 0 ? ref4 : "";
    }, [
        JSON.stringify(filters !== null && filters !== void 0 ? filters : {})
    ]);
    var getNextState = function() {
        var indice = getIndiceFromSortBy(sortBy, defaultIndex, locale);
        // We need to check here if filters value are different from initial values
        var isFiltering = initialQuery.current.index !== indice || JSON.stringify(initialQuery.current.facetFilters) !== JSON.stringify(facetFilters);
        var withoutExcludeIds = step === LayoutSwitcherProvider/* LAYOUT.SMALL */._.SMALL || isFiltering && isMounted.current;
        var processedFilters = (0,serialize_algolia_results/* processAlgoliaFilters */.UG)([
            numericFilters,
            initialFilters === null || initialFilters === void 0 ? void 0 : initialFilters.newProductsFilter,
            initialFilters === null || initialFilters === void 0 ? void 0 : initialFilters.publishedAtFilters,
            withoutExcludeIds ? "" : initialFilters === null || initialFilters === void 0 ? void 0 : initialFilters.excludeIds, 
        ]);
        /* Algolia expect an array of arrays for each facet you want to retrieve like [['concerns:concern1', 'concerns:concern2'],['categories:categorie1', 'categories:categorie2']] */ return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _), {
            page: algoliaPage,
            hitsPerPage: customLayout ? FilterProvider/* HITS_PER_PAGE.FILTERED */.Iq.FILTERED : hitsPerPage,
            filters: processedFilters,
            facetFilters: facetFilters,
            index: indice
        });
    };
    (0,react.useEffect)(function() {
        var ref;
        if (facetFilters === undefined) return;
        if (defaultFilters) {
            if (!isMounted.current) {
                isMounted.current = true;
                return;
            }
        }
        /* Algolia expect an array of arrays for each facet you want to retrieve like [['concerns:concern1', 'concerns:concern2'],['categories:categorie1', 'categories:categorie2']] */ var nextState = getNextState();
        var shouldChange = ((ref = Object.entries(_).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            return JSON.stringify(nextState === null || nextState === void 0 ? void 0 : nextState[key]) !== JSON.stringify(value);
        })) === null || ref === void 0 ? void 0 : ref.length) > 0;
        if (!shouldChange) return;
        setQuery(nextState);
    }, [
        filters,
        facetFilters,
        hitsPerPage,
        algoliaPage,
        currentPage
    ]);
    var results = data === null || data === void 0 ? void 0 : (ref1 = data.pages) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(acc, page) {
        return (0,_to_consumable_array/* default */.Z)((0,serialize_algolia_results/* serializeAlgoliaResults */.nZ)(acc)).concat((0,_to_consumable_array/* default */.Z)((0,serialize_algolia_results/* serializeAlgoliaResults */.nZ)(page.hits)));
    }, []);
    var processedQuery = (0,react.useMemo)(function() {
        var ref, ref1, ref2, ref3;
        if (!mounted) return {};
        var ref4;
        var newQueryObject = (ref4 = (ref2 = (ref1 = Object.entries((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query, ((ref = Object.keys(filters)) === null || ref === void 0 ? void 0 : ref.length) > 0 ? filters : {}), {
            layout: step
        }))) === null || ref1 === void 0 ? void 0 : ref1.filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            return(// remove unwanted parameters from url
            value !== null && key !== "uid" && key !== "uids" && key !== "page");
        })) === null || ref2 === void 0 ? void 0 : ref2.reduce(getReducedQueryValuesForFilters(facets), {})) !== null && ref4 !== void 0 ? ref4 : {};
        var ref5;
        var newQueryObjectMinusUnusedParams = (ref5 = (ref3 = Object.entries(newQueryObject)) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(cur, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            var shouldRemoveKey = REMOVABLE_EMPTY_KEYS.indexOf(key) !== -1 && Array.isArray(value) && (value === null || value === void 0 ? void 0 : value.length) === 0 && !(filteredParamsFromUrl === null || filteredParamsFromUrl === void 0 ? void 0 : filteredParamsFromUrl[key]);
            if (shouldRemoveKey) return cur;
            return Object.assign(cur, (0,_define_property/* default */.Z)({}, key, value));
        }, {})) !== null && ref5 !== void 0 ? ref5 : {};
        return(// The next query parameters are
        // current query parameters + current filters with values + current layout state
        newQueryObjectMinusUnusedParams !== null && newQueryObjectMinusUnusedParams !== void 0 ? newQueryObjectMinusUnusedParams : {});
    }, [
        JSON.stringify(filters !== null && filters !== void 0 ? filters : {}),
        step
    ]);
    var hasParams = !!((ref2 = Object.keys(processedQuery)) === null || ref2 === void 0 ? void 0 : ref2.length);
    // Push to url the updated params from filter providers
    (0,react.useEffect)(function() {
        if (!mounted || !hasParams) return;
        // Push to new route if processedQuery is different from current url params
        if (!(0,deep_equal/* default */.Z)(filteredParamsFromUrl, processedQuery)) {
            routerPush(processedQuery);
        }
    }, [
        processedQuery
    ]);
    (0,react.useEffect)(function() {
        if ((params === null || params === void 0 ? void 0 : params.layout) && (params === null || params === void 0 ? void 0 : params.layout) !== LayoutSwitcherProvider/* LAYOUT.MEDIUM */._.MEDIUM) {
            setStep(params === null || params === void 0 ? void 0 : params.layout);
        }
        if (!(0,deep_equal/* default */.Z)(filteredParamsFromUrl, filters)) {
            setFilters(filteredParamsFromUrl);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: PageWithFilters_cx((PageWithFilters_styles_module_default()).section, gridStyle),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_FiltersTrigger, {
                        className: PageWithFilters_cx((PageWithFilters_styles_module_default()).filtersTrigger, {
                            isBannerVisible: isVisible,
                            isEnd: isInview && !customLayout,
                            customLayout: customLayout
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: PageWithFilters_cx((PageWithFilters_styles_module_default()).content),
                        children: isSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_FilteredProductsGrid, {
                            hasResults: (results === null || results === void 0 ? void 0 : results.length) > 0,
                            results: results,
                            filteredHeaderBlock: filteredHeader,
                            currentPage: currentPage,
                            customLayout: customLayout,
                            maxPage: data === null || data === void 0 ? void 0 : (ref3 = data.pages) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.nbPages,
                            randomImages: randomImages,
                            withPriority: withPriority
                        }) : isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                            className: (PageWithFilters_styles_module_default()).spinner,
                            color: colors/* GlobalThemeColors.Black */.b.Black
                        })
                    }),
                    !customLayout && /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_FiltersTrigger, {
                        className: PageWithFilters_cx((PageWithFilters_styles_module_default()).filtersTriggerBottom, {
                            isBannerVisible: isVisible,
                            isEnd: isInview && !customLayout
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: PageWithFilters_cx((PageWithFilters_styles_module_default()).marker),
                        ref: inViewRef
                    })
                ]
            }),
            (results === null || results === void 0 ? void 0 : results.length) > 0 && (data === null || data === void 0 ? void 0 : (ref5 = data.pages) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.nbPages) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                className: PageWithFilters_cx((PageWithFilters_styles_module_default()).pagination),
                maxPage: data === null || data === void 0 ? void 0 : (ref7 = data.pages) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.nbPages
            }),
            children
        ]
    });
}
PageWithFilters.defaultProps = {};
function PageWithFiltersWrapper(_param) {
    var children = _param.children, excludeIds = _param.excludeIds, algoliaProps = _param.algoliaProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "excludeIds",
        "algoliaProps"
    ]);
    var asPath = (0,next_router.useRouter)().asPath;
    var locale = (0,useLocale/* default */.Z)();
    var ref = (0,FilterProvider/* useFilter */.L0)(), defaultFilters = ref.defaultFilters, hitsPerPage = ref.hitsPerPage;
    var _initialFilters;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AlgoliaSearchProvider/* AlgoliaSearchProvider */.C, {
        queryKey: asPath,
        appId: "R7QBW7H08I",
        apiKey: "9483d8afa1ebc9822ce3e3c7e5b7761a",
        initialSearchProps: (0,_object_spread/* default */.Z)({
            hitsPerPage: hitsPerPage,
            index: "".concat(locale, "_").concat((0,get_algolia_product_index/* default */.Z)()),
            facetFilters: "".concat((0,FilterProvider/* getFacetsFiltersFromFilters */.ty)(defaultFilters)),
            filters: (0,serialize_algolia_results/* processAlgoliaFilters */.UG)(Object.values((_initialFilters = props.initialFilters) !== null && _initialFilters !== void 0 ? _initialFilters : {}))
        }, algoliaProps === null || algoliaProps === void 0 ? void 0 : algoliaProps.params),
        defaultQueryOptions: {
            refetchOnMount: false,
            initialData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, algoliaProps === null || algoliaProps === void 0 ? void 0 : algoliaProps.initialData), {
                pageParams: []
            })
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWithFilters, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            excludeIds: excludeIds,
            algoliaProps: algoliaProps,
            children: children
        }))
    });
}


/***/ }),

/***/ 4017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_UI_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51025);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92962);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);






var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()));
function BannerImage(param) {
    var className = param.className, image = param.image, mobileImage = param.mobileImage;
    var imgProps = {
        asPlaceholder: true,
        layout: "fill",
        objectFit: "cover"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().BannerImage), className),
        children: [
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().image), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().hideOnSmallScreen))
            }, imgProps, image), {
                priority: true,
                sizesFromBreakpoints: [
                    {
                        breakpoint: "lg",
                        ratio: 24 / 24
                    },
                    {
                        ratio: 16 / 16
                    }, 
                ]
            })),
            mobileImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().image), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().hideOnLargeScreen)),
                ratio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().ratio)
            }, imgProps, mobileImage), {
                priority: true,
                sizesFromBreakpoints: [
                    {
                        breakpoint: "lg",
                        ratio: 24 / 24
                    },
                    {
                        ratio: 16 / 16
                    }, 
                ]
            }))
        ]
    });
}
BannerImage.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (BannerImage);


/***/ }),

/***/ 20449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Pagination; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@types/breakpoints.ts
var breakpoints = __webpack_require__(59646);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-slider/dist/es/hooks/useSliderState/index.js
var useSliderState = __webpack_require__(80581);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-slider/dist/es/index.js + 19 modules
var es = __webpack_require__(7924);
// EXTERNAL MODULE: ./src/components/Abstracts/Icons/index.tsx + 15 modules
var Icons = __webpack_require__(1815);
// EXTERNAL MODULE: ./src/providers/FilterProvider/index.tsx
var FilterProvider = __webpack_require__(42193);
// EXTERNAL MODULE: ./src/providers/PaginationProvider/index.tsx
var PaginationProvider = __webpack_require__(49981);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/hooks/useBreakpoint/index.ts + 4 modules
var useBreakpoint = __webpack_require__(7695);
// EXTERNAL MODULE: ./src/hooks/useLocale/index.ts
var useLocale = __webpack_require__(66794);
// EXTERNAL MODULE: ./src/components/Abstracts/Pagination/styles.module.scss
var styles_module = __webpack_require__(14699);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/Pagination/index.tsx



















var cx = bind_default().bind((styles_module_default()));
var ITEMS_LENGTH_DESKTOP = 15;
var ITEMS_LENGTH_MOBILE = 10;
function Pagination(param) {
    var className = param.className, maxPage = param.maxPage;
    var ref;
    var router = (0,next_router.useRouter)();
    var locale = (0,useLocale/* default */.Z)();
    var ref1 = (0,PaginationProvider/* usePagination */.h0)(), currentPage = ref1.currentPage, getRouterParams = ref1.getRouterParams;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useSliderState/* default */.Z)(), 2), ref3 = ref2[0], setSlideIndex = ref3.setSlideIndex, slideIndex = ref3.slideIndex, nextSlide = ref3.nextSlide, prevSlide = ref3.prevSlide, setSliderState = ref2[1];
    var ref4 = (0,react.useState)(), initialIndex = ref4[0], setInitialIndex = ref4[1];
    var ref5 = (0,react.useState)(ITEMS_LENGTH_DESKTOP), itemsVisible = ref5[0], setItemsVisible = ref5[1];
    var userFiltering = (0,FilterProvider/* useFilter */.L0)().userFiltering;
    var customSliderRef = (0,react.useRef)();
    var slidedIndex = (0,react.useRef)(initialIndex);
    var isMobile = (0,useBreakpoint/* default */.Z)(breakpoints/* GLOBAL_BREAKPOINTS.MD */.L.MD);
    var maxIndex = maxPage - itemsVisible;
    var linkStyle = (0,StyleProvider/* useStyle */.X)({
        color: colors/* GlobalThemeColors.Black */.b.Black,
        textPreset: text_preset/* GlobalTextPreset.Cta12GroteskRegular */.C.Cta12GroteskRegular,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    (0,react.useEffect)(function() {
        isMobile ? setItemsVisible(ITEMS_LENGTH_MOBILE) : setItemsVisible(ITEMS_LENGTH_DESKTOP);
    }, [
        isMobile
    ]);
    (0,react.useEffect)(function() {
        if (currentPage < 2) setInitialIndex(0);
        else if (currentPage > maxIndex) setInitialIndex(maxIndex);
        else setInitialIndex(currentPage - 3);
    }, [
        currentPage,
        maxIndex
    ]);
    (0,react.useEffect)(function() {
        if (initialIndex !== slideIndex) {
            setSlideIndex(initialIndex);
        }
    }, [
        initialIndex
    ]);
    var renderLink = function(value) {
        // Get router params and pass page value
        var params = getRouterParams(value);
        return Boolean(value) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            prefetch: false,
            // We are using an href so this is not a shallow push
            onClick: function(e) {
                e.preventDefault();
                router.push(params, undefined, {
                    shallow: true,
                    locale: locale
                });
            },
            href: params,
            shallow: userFiltering,
            locale: locale,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: cx((styles_module_default()).link, currentPage === value && (styles_module_default()).active, linkStyle),
                children: value
            })
        }, value);
    };
    var renderArrow = function(orientation) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: cx((styles_module_default()).arrow, (styles_module_default())[orientation]),
            onClick: function() {
                return orientation === "left" ? prevSlide() : nextSlide();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ArrowLeftIcon */.Y4, {
                className: (styles_module_default()).icon
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).sliderContainer,
            style: {
                width: 24 * itemsVisible
            },
            children: [
                slideIndex > 0 && renderArrow("left"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.ZP, {
                    className: cx((styles_module_default()).slider),
                    setSliderState: setSliderState,
                    initialSlideIndex: initialIndex,
                    snap: true,
                    autoBlockSlideIndexChange: true,
                    ref: customSliderRef,
                    onSlideIndexChange: function(index) {
                        return slidedIndex.current = index;
                    },
                    children: (ref = (0,_to_consumable_array/* default */.Z)(Array(maxPage + 1))) === null || ref === void 0 ? void 0 : ref.map(function(_, index) {
                        return renderLink(index);
                    })
                }),
                slideIndex < maxIndex && renderArrow("right")
            ]
        })
    });
}
Pagination.defaultProps = {};
/* harmony default export */ var Abstracts_Pagination = (Pagination);

// EXTERNAL MODULE: ./src/components/UI/Pagination/styles.module.scss
var Pagination_styles_module = __webpack_require__(29196);
var Pagination_styles_module_default = /*#__PURE__*/__webpack_require__.n(Pagination_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/Pagination/index.tsx








var Pagination_cx = bind_default().bind((Pagination_styles_module_default()));
function Pagination_Pagination(_param) {
    var className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: Pagination_cx((Pagination_styles_module_default()).Pagination, className, gridStyle),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Abstracts_Pagination, (0,_object_spread/* default */.Z)({
            className: Pagination_cx((Pagination_styles_module_default()).content)
        }, rest))
    });
}
Pagination_Pagination.defaultProps = {};
/* harmony default export */ var UI_Pagination = (Pagination_Pagination);


/***/ }),

/***/ 52763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UG": function() { return /* binding */ processAlgoliaFilters; },
/* harmony export */   "nZ": function() { return /* binding */ serializeAlgoliaResults; }
/* harmony export */ });
/* unused harmony exports SUB_CATEGORIES_SEPARATOR, getDefaultFacetsFromAlgoliaProps */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _lib_algolia_sync_set_settings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10348);
/* harmony import */ var _utils_check_empty_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86867);







var SUB_CATEGORIES_SEPARATOR = " > ";
function serializeAlgoliaResults(hits) {
    return hits === null || hits === void 0 ? void 0 : hits.map(function(hit) {
        var ref;
        if (hit === null || hit === void 0 ? void 0 : hit.productCard) return hit;
        var _ref = hit !== null && hit !== void 0 ? hit : {}, shopify = _ref.shopify, storyblok = _ref.storyblok, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, [
            "shopify",
            "storyblok"
        ]);
        var ref1, ref2, ref3;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, rest), {
            shopifyId: (ref1 = shopify === null || shopify === void 0 ? void 0 : shopify.shopifyId) !== null && ref1 !== void 0 ? ref1 : null
        }), storyblok), {
            wishlistDetails: {
                inList: true,
                uuid: (ref2 = storyblok === null || storyblok === void 0 ? void 0 : storyblok.uuid) !== null && ref2 !== void 0 ? ref2 : null,
                variantId: shopify === null || shopify === void 0 ? void 0 : (ref = shopify.defaultVariant) === null || ref === void 0 ? void 0 : ref.id
            },
            variants: (ref3 = shopify === null || shopify === void 0 ? void 0 : shopify.variants) !== null && ref3 !== void 0 ? ref3 : null,
            productCard: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, shopify, storyblok)
        });
    });
}
function processAlgoliaFilters(filters) {
    var ref;
    var ref1;
    return (ref1 = (ref = filters === null || filters === void 0 ? void 0 : filters.filter(function(string) {
        return (0,_utils_check_empty_string__WEBPACK_IMPORTED_MODULE_4__/* .stringIsNotEmpty */ .b)(string);
    })) === null || ref === void 0 ? void 0 : ref.join(" AND ")) !== null && ref1 !== void 0 ? ref1 : "";
}
/**
 * It takes a list of facets and returns a list of facets, but with the subcategories of each category
 * added to the category
 * @param {FacetsResult[]} facets - FacetsResult[]
 * @returns An array of facets, with the subcategories nested under the categories.
 */ function processCategoriesAndSubCategoriesFacets(facets) {
    var ref;
    // Isolate categories facet
    var categories = facets === null || facets === void 0 ? void 0 : facets.find(function(entry) {
        return (entry === null || entry === void 0 ? void 0 : entry.type) === FACETS.CATEGORIES_V2;
    });
    // Isolate sub categories facet
    var subCategories = facets === null || facets === void 0 ? void 0 : facets.find(function(entry) {
        return (entry === null || entry === void 0 ? void 0 : entry.type) === FACETS.SUB_CATEGORIES;
    });
    return (ref = facets === null || facets === void 0 ? void 0 : facets.filter(function(facet) {
        // If there is no facet categories then we don't want to hide the sub categories
        if (!categories) return facet;
        // If there is a categories facet then we want to hide to hide the sub categories
        // As they will be displayed under each relevant category
        return (facet === null || facet === void 0 ? void 0 : facet.type) !== FACETS.SUB_CATEGORIES;
    })) === null || ref === void 0 ? void 0 : ref.map(function(facet) {
        var ref;
        // If there is no categories facet
        if (!categories && (facet === null || facet === void 0 ? void 0 : facet.type) === FACETS.SUB_CATEGORIES) {
            var ref1;
            return _object_spread_props(_object_spread({}, facet), {
                // Map over each sub categories facet value
                values: facet === null || facet === void 0 ? void 0 : (ref1 = facet.values) === null || ref1 === void 0 ? void 0 : ref1.map(function(entry) {
                    var ref, ref1, ref2;
                    var hasParentFacet = entry === null || entry === void 0 ? void 0 : (ref = entry.label) === null || ref === void 0 ? void 0 : ref.includes(SUB_CATEGORIES_SEPARATOR);
                    return _object_spread_props(_object_spread({}, entry), {
                        // Remove parent category string (category > sub category)
                        label: hasParentFacet ? (ref2 = entry === null || entry === void 0 ? void 0 : (ref1 = entry.label) === null || ref1 === void 0 ? void 0 : ref1.split(SUB_CATEGORIES_SEPARATOR)) === null || ref2 === void 0 ? void 0 : ref2[1] : entry === null || entry === void 0 ? void 0 : entry.label
                    });
                })
            });
        }
        // If there are categories and current facet is not category then it doesn't need to be processed
        if ((facet === null || facet === void 0 ? void 0 : facet.type) !== FACETS.CATEGORIES_V2) return facet;
        return _object_spread_props(_object_spread({}, facet), {
            // Add a sub values object with relevant sub categories
            subValues: {
                type: FACETS.SUB_CATEGORIES,
                values: facet === null || facet === void 0 ? void 0 : (ref = facet.values) === null || ref === void 0 ? void 0 : ref.reduce(function(acc, entry) {
                    var ref, ref1;
                    // Isolate category name (eg: Bagues)
                    var categoryName = entry.label;
                    // Isolate the category string to trim (eg: Bagues >)
                    var str = "".concat(categoryName, " >");
                    var ref2;
                    return _object_spread_props(_object_spread({}, acc), // Create object {[catName]: [...subValues]}
                    // eg: {Bagues: [{label: "Alliances", value: "Bagues > Alliances"}]}
                    _define_property({}, categoryName, (ref2 = (ref1 = subCategories === null || subCategories === void 0 ? void 0 : (ref = subCategories.values) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
                        var ref;
                        return item === null || item === void 0 ? void 0 : (ref = item.label) === null || ref === void 0 ? void 0 : ref.startsWith(str);
                    })) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                        var ref;
                        return _object_spread_props(_object_spread({}, item), {
                            // Format facet label string
                            label: item === null || item === void 0 ? void 0 : (ref = item.label) === null || ref === void 0 ? void 0 : ref.replace(str, "")
                        });
                    })) !== null && ref2 !== void 0 ? ref2 : []));
                }, {})
            }
        });
    });
}
var STONES_FACET_VALUES_AMOUNT_TO_DISPLAY = 15;
/**
 * It takes the initial data from Algolia and returns an array of facets
 * @param {AlgoliaInitialSearchResponse} data - AlgoliaInitialSearchResponse
 * @returns An array of objects with the following shape:
 * {
 *   type: string,
 *   values: [
 *     {
 *       label: string,
 *       value: string,
 *     }
 *   ]
 * }
 */ function getDefaultFacetsFromAlgoliaProps(data, filters) {
    var ref, ref1, ref2, ref3, ref4;
    var ref5;
    var facets = (ref5 = data === null || data === void 0 ? void 0 : (ref = data.initialData) === null || ref === void 0 ? void 0 : (ref1 = ref.pages) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.facets) !== null && ref5 !== void 0 ? ref5 : {};
    var ref6;
    var processedFacets = (ref6 = (ref4 = (ref3 = Object.entries(facets)) === null || ref3 === void 0 ? void 0 : ref3.filter(function(param) {
        var _param = _sliced_to_array(param, 1), key = _param[0];
        var ref;
        return !((ref = Object.keys(filters)) === null || ref === void 0 ? void 0 : ref.includes(key));
    })) === null || ref4 === void 0 ? void 0 : ref4.map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        var ref, ref1, ref2, ref3;
        /**
         * For the stores facet values, WB team decided decided there were too many options listed
         * To fix this, we will only display the X stones with the most results
         */ var values = // If current facet is stones
        key === FACETS.STONE ? (ref2 = (ref1 = (ref = Object.keys(value)) === null || ref === void 0 ? void 0 : ref.sort(function(currentKey, nextKey) {
            return value[nextKey] - value[currentKey];
        })) === null || ref1 === void 0 ? void 0 : ref1.slice(0, STONES_FACET_VALUES_AMOUNT_TO_DISPLAY)) === null || ref2 === void 0 ? void 0 : ref2.sort() : Object.keys(value);
        var ref4;
        return {
            type: key,
            values: (ref4 = (ref3 = values === null || values === void 0 ? void 0 : values.map(function(val) {
                return {
                    label: val,
                    value: val
                };
            })) === null || ref3 === void 0 ? void 0 : ref3.filter(function(item) {
                return item;
            })) !== null && ref4 !== void 0 ? ref4 : []
        };
    })) !== null && ref6 !== void 0 ? ref6 : [];
    return processCategoriesAndSubCategoriesFacets(processedFacets);
}


/***/ }),

/***/ 17831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getAlgoliaProductIndex; }
/* harmony export */ });
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96660);

function getAlgoliaProductIndex() {
    return "".concat("production", "_").concat(_lib_constants__WEBPACK_IMPORTED_MODULE_0__/* .ALGOLIA_PRODUCT_INDEX */ .of);
}


/***/ }),

/***/ 14699:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"styles_sliderContainer__vxeEy","arrow":"styles_arrow__BnMkU","left":"styles_left___lXTo","icon":"styles_icon__7MwCV","right":"styles_right__sp9Pq","slider":"styles_slider__n02c6","link":"styles_link__msTqa","active":"styles_active__Jdkgc"};

/***/ }),

/***/ 35995:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__qaSsP","marker":"styles_marker__JCA4g","filtersTrigger":"styles_filtersTrigger__as9uT","customLayout":"styles_customLayout__SMh6T","isEnd":"styles_isEnd__WsA1l","isBannerVisible":"styles_isBannerVisible__vVTf0","filtersTriggerBottom":"styles_filtersTriggerBottom___j5Q7","header":"styles_header__HFFWo","content":"styles_content__2fekM","noResults":"styles_noResults__PQF1e","spinnerWrapper":"styles_spinnerWrapper__KKHhj","spinner":"styles_spinner__RDuxu","product":"styles_product__T3HQ6","pagination":"styles_pagination__tJKHf"};

/***/ }),

/***/ 92962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BannerImage":"styles_BannerImage__B7wAd","hideOnSmallScreen":"styles_hideOnSmallScreen__4Wyi3","hideOnLargeScreen":"styles_hideOnLargeScreen__dzHZB","ratio":"styles_ratio__p2tA_","image":"styles_image__CI10l"};

/***/ }),

/***/ 3207:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"FilteredHeaderBlock":"styles_FilteredHeaderBlock__F9nTS","isBannerVisible":"styles_isBannerVisible__W4mgw","bioImage":"styles_bioImage__5ViiH","text":"styles_text__N_LpZ","bio":"styles_bio__3opdu","readMore":"styles_readMore__bwbl5","readLess":"styles_readLess__HTcm5","materials":"styles_materials__1RBMQ","origin":"styles_origin__0YRCo","responsibilities":"styles_responsibilities__UaLeD","shops":"styles_shops__URb5F","elements":"styles_elements__hLF51","responsibility":"styles_responsibility__wrzL_","shop":"styles_shop__BO629"};

/***/ }),

/***/ 38071:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product":"styles_product__YTJx7"};

/***/ }),

/***/ 40986:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductsGrid":"styles_ProductsGrid__hqQTE","hideOnSmallScreen":"styles_hideOnSmallScreen__vVeQX","hideOnLargeScreen":"styles_hideOnLargeScreen__c9iFw","customDetails":"styles_customDetails__7q3Vp","big":"styles_big__Y_ORG","medium":"styles_medium__FZXZk","small":"styles_small__AMgMa","customLayout":"styles_customLayout__f3UTq","imageContainer":"styles_imageContainer__PZxXm","image":"styles_image__OWaBo","noResults":"styles_noResults__fDCs0"};

/***/ }),

/***/ 63159:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"FiltersTrigger":"styles_FiltersTrigger__ljf0I","icon":"styles_icon__TK0Mr"};

/***/ }),

/***/ 29196:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"styles_Pagination__illu0","content":"styles_content__IyxbP"};

/***/ })

}]);